import { render, staticRenderFns } from "./IgnoreDiscountsForm.vue?vue&type=template&id=9efebb18&scoped=true&"
import script from "./IgnoreDiscountsForm.vue?vue&type=script&lang=js&"
export * from "./IgnoreDiscountsForm.vue?vue&type=script&lang=js&"
import style0 from "./IgnoreDiscountsForm.vue?vue&type=style&index=0&id=9efebb18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efebb18",
  null
  
)

export default component.exports